import { NoteStatus, NoteType } from "@/api/dtos";
import { ChipProps } from "@mui/material";

const mapping: Record<NoteStatus, ChipProps['color']> = {
    [NoteStatus.Closed]: 'success',
    [NoteStatus.New]: 'error',
    [NoteStatus.NotApplicable]: 'default',
    [NoteStatus.ResolutionProposed]: 'info',
    [NoteStatus.Updated]: 'warning',
};

const noteStatusToColor = (status?: NoteStatus) => {
    if (!status) {
        return 'default'
    }

    return mapping[status];
}

export default noteStatusToColor;